import { Link } from "react-router-dom";
import { ArrowLeft, Warning, Storefront } from "@phosphor-icons/react";

export default function TermsBusinesses() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10 text-white/80 leading-relaxed">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6" data-testid="biz-terms-back">
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <div className="flex items-center gap-2 mb-3">
          <Storefront weight="fill" size={22} className="text-[#B4F34A]" />
          <p className="text-sm uppercase tracking-widest text-[#B4F34A]">Documento legal · Comercios</p>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-2">Términos del Servicio para Comercios</h1>
        <p className="text-white/40 text-sm mb-10">Última actualización: junio de 2026</p>

        <div className="rounded-2xl bg-[#FFB800]/5 border border-[#FFB800]/20 p-5 mb-8 flex items-start gap-3">
          <Warning size={22} weight="fill" className="text-[#FFB800] shrink-0 mt-0.5" />
          <p className="text-sm text-white/80">
            Este contrato regula el uso de Tu MusiKa Negocios por parte de restaurantes, bares, cafeterías, comercios y franquicias suscritos. Léelo con atención antes de contratar.
          </p>
        </div>

        <Section title="1. Identidad del Proveedor">
          <p>
            <strong className="text-white">Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong> (en adelante &ldquo;la Empresa&rdquo;, &ldquo;el Proveedor&rdquo; o &ldquo;Tu MusiKa&rdquo;), con domicilio en Av. Américas 1545, Col. Providencia, Guadalajara, Jalisco, México, es la titular y operadora de la plataforma <strong className="text-white">tumusika.com</strong> y del servicio Tu MusiKa Negocios.
          </p>
        </Section>

        <Section title="2. Objeto del contrato">
          <p>
            Este contrato regula el otorgamiento de una <strong className="text-white">licencia no exclusiva, intransferible y revocable</strong> que faculta al Comercio para reproducir públicamente, dentro de su(s) establecimiento(s) registrado(s), el catálogo musical original disponible en la plataforma. La licencia se otorga a cambio del pago de la cuota mensual o anual del plan contratado.
          </p>
        </Section>

        <Section title="3. Planes y precios">
          <p>Los precios están expresados en pesos mexicanos (MXN) e incluyen los impuestos aplicables.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4">
            <PlanCard name="Plan Básico" price="$299 MXN / mes" desc="Microempresas, locales pequeños, cafeterías independientes, estéticas, consultorios." />
            <PlanCard name="Plan Pro" price="$599 MXN / mes" desc="Restaurantes y bares medianos. Incluye programación por horarios, personalización con IA y anuncios de voz." />
            <PlanCard name="Plan Premium / Multilocal" price="$1,199 MXN / mes por sucursal" desc="Salones de baile, sonideros, cadenas y franquicias. Con 10+ sucursales: $499 MXN por sucursal. Incluye panel multilocal y soporte 24/7." />
          </div>
          <p className="mt-4">
            Pago anual: <strong className="text-white">descuento del 20%</strong> al adquirir 12 meses por adelantado.
          </p>
        </Section>

        <Section title="4. Forma de pago y vigencia">
          <p>
            El Comercio paga por transferencia bancaria SPEI a la cuenta BBVA del beneficiario <strong className="text-white">Ricardo Zermeño Mejía</strong>, registrando su comprobante en la plataforma. La Empresa valida y activa la licencia en un plazo máximo de 24 horas hábiles.
          </p>
          <p className="mt-2">
            La vigencia inicia desde la confirmación del pago y se extiende 30 días (plan mensual) o 365 días (plan anual). El Comercio puede renovar antes del vencimiento; en caso de no renovar, la reproducción se suspenderá automáticamente al expirar la vigencia.
          </p>
        </Section>

        <Section title="5. Número de Comercio Autorizado y antifraude">
          <p>
            Al registrarse, el Comercio recibe un <strong className="text-white">Número de Comercio Autorizado</strong> único y permanente (formato TM-XXXXXX). Este número identifica al Comercio frente a la Empresa y autoriza la reproducción pública del catálogo en sus instalaciones.
          </p>
          <p className="mt-2">
            <strong className="text-white">El número es personal e intransferible.</strong> El reproductor web asocia automáticamente el Número de Comercio a la red de internet del primer dispositivo que lo activa. Cualquier intento de uso desde otra red distinta es bloqueado y notificado al Proveedor.
          </p>
          <p className="mt-2">
            La cesión, préstamo, venta o uso del Número de Comercio fuera del establecimiento contratado constituye un <strong className="text-white">incumplimiento grave</strong> que faculta al Proveedor a suspender el servicio sin reembolso y a iniciar las acciones legales correspondientes por daños y perjuicios.
          </p>
        </Section>

        <Section title="6. Catálogo y derechos de autor">
          <p>
            Todo el contenido musical disponible es <strong className="text-white">creación original</strong> de los usuarios de la plataforma, quienes han otorgado licencia no exclusiva a la Empresa para su explotación comercial dentro del servicio Tu MusiKa Negocios. Por lo anterior:
          </p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li>El Comercio queda <strong className="text-white">libre de la obligación de pagar regalías a sociedades de gestión colectiva</strong> (SACM, ANDI, EMMAC, etc.) por las obras del catálogo Tu MusiKa.</li>
            <li>La Empresa se obliga a mantener el catálogo libre de obras protegidas por terceros y a sustituir inmediatamente cualquier obra que resulte cuestionada.</li>
            <li>El Comercio no adquiere ningún derecho de reproducción mecánica, fonográfica o de explotación comercial distinto al de reproducción pública dentro de su(s) establecimiento(s).</li>
            <li>Queda <strong className="text-white">prohibido grabar, descargar fuera de la plataforma, retransmitir por internet, sincronizar con video, o subir a redes sociales</strong> las obras del catálogo. Toda explotación distinta requiere licencia adicional.</li>
          </ul>
        </Section>

        <Section title="7. Funcionalidades por plan">
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li><strong className="text-white">Plan Básico:</strong> reproducción aleatoria del catálogo, sin anuncios.</li>
            <li><strong className="text-white">Plan Pro:</strong> programación por horarios (música tranquila en la mañana, movida en la noche), personalización con IA en tiempo real, inserción de anuncios de voz propios del Comercio.</li>
            <li><strong className="text-white">Plan Premium:</strong> todo lo anterior, panel de administración centralizado para múltiples sucursales, soporte 24/7 e identidad sonora de IA exclusiva.</li>
          </ul>
          <p className="mt-3">
            Las funcionalidades de IA se ofrecen <strong className="text-white">en la medida en que los proveedores tecnológicos del Proveedor las hagan disponibles</strong>; mantenimientos programados o caídas de servicios externos no constituyen incumplimiento del Proveedor.
          </p>
        </Section>

        <Section title="8. Anuncios de voz propios (Plan Pro y Premium)">
          <p>
            El Comercio es el único responsable del contenido, veracidad y legalidad de los anuncios de voz que insiera en su programación. La Empresa se reserva el derecho de retirar anuncios que infrinjan la Ley Federal de Protección al Consumidor, la Ley General de Salud, derechos de terceros o las buenas costumbres.
          </p>
        </Section>

        <Section title="9. Suspensión y cancelación">
          <p>
            La Empresa puede suspender el servicio en caso de: (i) falta de pago al vencimiento, (ii) uso fraudulento del Número de Comercio, (iii) reproducción pública del catálogo fuera del establecimiento registrado, (iv) uso para fines ilícitos, o (v) violación reiterada de estos términos.
          </p>
          <p className="mt-2">
            El Comercio puede cancelar su suscripción en cualquier momento; no se otorgan reembolsos por periodos ya pagados, pero el servicio permanece activo hasta el vencimiento del periodo en curso.
          </p>
        </Section>

        <Section title="10. Protección de datos">
          <p>
            La Empresa trata los datos personales del Comercio conforme a su <Link to="/aviso-de-privacidad" className="text-[#B4F34A] underline">Aviso de Privacidad</Link>. Los datos bancarios del Comercio sólo se utilizan para validar pagos.
          </p>
        </Section>

        <Section title="11. Limitación de responsabilidad">
          <p>
            La responsabilidad máxima del Proveedor frente al Comercio se limita al monto efectivamente pagado por éste en los últimos tres (3) meses. El Proveedor no responde por lucro cesante, daños indirectos, o por la imposibilidad temporal de reproducir música derivada de fallos de internet del Comercio, de su equipo de sonido o de proveedores tecnológicos externos.
          </p>
        </Section>

        <Section title="12. Modificaciones">
          <p>
            La Empresa puede modificar estos términos. Los cambios surten efecto al publicarse y se notifican al Comercio por WhatsApp y/o correo. El uso continuado del servicio tras la modificación implica aceptación.
          </p>
        </Section>

        <Section title="13. Jurisdicción">
          <p>
            Estos términos se rigen por las leyes mexicanas. Para cualquier controversia, las partes se someten a los tribunales competentes de la ciudad de <strong className="text-white">Guadalajara, Jalisco</strong>, renunciando a cualquier otro fuero.
          </p>
        </Section>

        <Section title="14. Contacto">
          <p>
            Soporte y aclaraciones por WhatsApp <span className="font-mono text-white">+52 33 4280 2102</span>.
          </p>
        </Section>

        <div className="mt-10 pt-6 border-t border-white/10 text-sm text-white/40">
          <p>Marketing de Inteligencia Artificial S. de R.L. de C.V. · Av. Américas 1545, Col. Providencia, Guadalajara, Jal., México.</p>
        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-white mb-3">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}

function PlanCard({ name, price, desc }) {
  return (
    <div className="rounded-2xl bg-[#121212] border border-white/10 p-4">
      <p className="font-display font-bold text-base text-[#FFB800]">{name}</p>
      <p className="text-sm font-semibold text-white mt-1">{price}</p>
      <p className="text-xs text-white/60 mt-2 leading-relaxed">{desc}</p>
    </div>
  );
}
